__turbopack_context__.v({
  "carouselContainer": "style-module-scss-module__5OFANa__carouselContainer",
  "component": "style-module-scss-module__5OFANa__component",
  "filters": "style-module-scss-module__5OFANa__filters",
  "header": "style-module-scss-module__5OFANa__header",
  "heading": "style-module-scss-module__5OFANa__heading",
});
